module.exports = __webpack_public_path__ + "img/top.8ad1588c.png";